import React, { useState } from 'react';
import {
	Radio,
	FormControlLabel,
	RadioGroup,
	makeStyles,
	useMediaQuery,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && 200,
		width: ({ isMobile, width }) => (isMobile ? 200 : width),
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ touched, hover }) =>
			touched || hover ? theme.palette.primary.main : 'black',
	},
}));

const SimpleRadioButton = ({
	label,
	name,
	value,
	onChange,
	options = [],
	labelPos = 'start',
	containerClass = '',
	className = '',
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, touched, hover });

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<RadioGroup
					name={name}
					value={value}
					onChange={onChange}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
					className={className}
				>
					{options.map((option) => (
						<FormControlLabel
							key={option.value}
							label={<div>{option.label}</div>}
							value={option.value}
							disabled={option.disabled}
							labelPlacement={option.labelPlace}
							control={<Radio color="primary" />}
						/>
					))}
				</RadioGroup>
			}
		/>
	);
};

export default SimpleRadioButton;
